module.exports = __webpack_public_path__ + "static/media/207-guam.8c887545.svg";